export const headerHeight = 64
export const headerHeightFull = 88
export const miniBarHeight = 31
